import React, { Component } from 'react';
import { Typography, Grid, Paper, Avatar, Card } from '@material-ui/core';
import { Android, Apple, MonetizationOn, GetApp, Group } from '@material-ui/icons'
import { blue, green, red } from '@material-ui/core/colors';



class HomeScreen extends Component {

    render() {
        return (
            <Grid>
                <Typography variant="h4">Home</Typography>
                {/*<Grid container spacing={3}>
                    <Grid item xs={6} md={4}>
                        <Paper style={{padding: 8, textAlign: 'center'}}>
                            <Typography variant="h4" style={{ margin: 10}}>Sales</Typography> 
                            <Card style={{ backgroundColor: blue[500]}}>
                                <Typography variant="h5" style={{ color: '#FFF'}}><MonetizationOn style={{marginBottom: -4}}/> 745.000</Typography>
                            </Card>

                            <Grid container spacing={5} >
                                <Grid item style={{ margin: 'auto' }}>
                                    <Avatar style={{ backgroundColor: blue[500], margin: 10}}>
                                        <Android style={{ color: '#FFF'}}/>
                                    </Avatar>
                                    <p style={{ fontSize: 'large', fontWeight: 'bolder'}}>$ 500k</p>
                                </Grid>
                                <Grid item style={{ margin: 'auto' }}>
                                    <Avatar style={{ backgroundColor: blue[500],  margin: 10}}>
                                        <Apple style={{ color: '#FFF'}}/>
                                    </Avatar>
                                    <p style={{ fontSize: 'large', fontWeight: 'bolder'}}>$ 245k</p>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>

                    <Grid item xs={6} md={4}>
                        <Paper style={{padding: 8, textAlign: 'center'}}>
                        <Typography variant="h4" style={{ margin: 10}}>Users</Typography> 
                            <Card style={{ backgroundColor: red[500]}}>
                                <Typography variant="h5" style={{ color: '#FFF'}}><Group style={{marginBottom: -4}}/> 40k</Typography>
                            </Card>
                        </Paper>
                    </Grid>

                    <Grid item xs={6} md={4}>
                        <Paper style={{ padding: 8, textAlign: 'center' }}>
                            
                            <Typography variant="h4" style={{ margin: 10}}>Downloads</Typography> 
                            <Card style={{ backgroundColor: green[500]}}>
                                <Typography variant="h5" style={{ color: '#FFF'}}><GetApp style={{marginBottom: -4}} /> 52k</Typography>
                            </Card>
                            

                            <Grid container spacing={5} >
                                <Grid item style={{ margin: 'auto' }}>
                                    <Avatar style={{ backgroundColor: green[500], margin: 10}}>
                                        <Android style={{ color: '#FFF'}}/>
                                    </Avatar>
                                    <p style={{ fontSize: 'large', fontWeight: 'bolder'}}>27k</p>
                                </Grid>
                                <Grid item style={{ margin: 'auto' }}>
                                    <Avatar style={{ backgroundColor: green[500],  margin: 10}}>
                                        <Apple style={{ color: '#FFF'}}/>
                                    </Avatar>
                                    <p style={{ fontSize: 'large', fontWeight: 'bolder'}}>25k</p>
                                </Grid>
                            </Grid>

                        </Paper>
                    </Grid>
                </Grid>
        */}
            </Grid>
        );
    }
}

export default (HomeScreen);